import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress,
} from '@mui/material';
import axiosInstance from '../../lib/axios';
import { toast } from 'react-toastify';

const EnquiryDataTable = ({ propId, bookDtFrom, checkoutDt, refreshTrigger }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchEnqTable();
        return () => {
            toast.dismiss();
        };
    }, [refreshTrigger]);

    const fetchEnqTable = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.post(
                'BedCalendar/DashboardEnq?currentPage=1&limit=15',
                {
                    PropId: propId || 2,
                    BookDtFrom: bookDtFrom || '2025-07-13',
                    CheckoutDt: checkoutDt || '2026-08-13',
                    Flag: 'TotalEnqStatusUser',
                    start: 1,
                    PageSize: 10,
                    SearchText: '',
                }
            );

            if (response.data.Status === 0) {
                setRows(response.data.Data || []);
            } else {
                setRows([]);
            }
        } catch (error) {
            toast.error('Error while fetching the data');
            setRows([]);
        }
        setLoading(false);
    };

    const getStatusColor = (status, isBg) => {
        if (!status) return isBg ? '#eeeeee' : '#000000';
        switch (status.toLowerCase()) {
            case 'open':
                return isBg ? '#e0f2f1' : '#00695c';
            case 'close':
                return isBg ? '#dfebdfff' : '#022406ff';
            case 'cancel':
                return isBg ? '#ffebee' : '#c62828';
            default:
                return isBg ? '#eeeeee' : '#000000';
        }
    };

    const StyledCell = ({ children, ...props }) => (
        <TableCell
            sx={{ py: '4px', fontSize: '0.875rem', lineHeight: 1.2 }}
            {...props}
        >
            {children}
        </TableCell>
    );

    const StatusBadge = ({ status = '', value = '0' }) => (
        <Box
            sx={{
                display: 'inline-block',
                px: 1.5,
                py: 0.3,
                borderRadius: '15px',
                fontSize: '12px',
                fontWeight: 500,
                backgroundColor: getStatusColor(status, true),
                color: getStatusColor(status, false),
            }}
        >
            {value}
        </Box>
    );

    return (
        <Box sx={{ p: 0 }}>
            {loading ? (
                <Box sx={{ textAlign: 'center', mt: 5 }}>
                    <CircularProgress size="3rem" color="primary" />
                </Box>
            ) : (
                <TableContainer
                    component={Paper}
                    elevation={3}
                    sx={{ borderRadius: 2, height: 260, overflowY: 'auto' }}
                >
                    <Table stickyHeader
                        sx={{
                            '& .MuiTableCell-root': {
                                border: '1px solid #ccc',
                            },
                            borderCollapse: 'collapse',
                        }}
                    >
                        <TableHead>
                            <TableRow sx={{ height: 32 }}>
                                {['Sr.No', 'User', 'Enquiry', 'FollowUp', 'Open', 'Closed', 'Cancel']
                                    .map((header) => (
                                        <TableCell
                                            key={header}
                                            sx={{
                                                position: 'sticky',
                                                top: 0,
                                                backgroundColor: '#f6f7f7ff',
                                                zIndex: 10,
                                                fontWeight: 'bold',
                                                py: '4px',
                                                fontSize: '0.875rem',
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No records found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                rows.map((row, index) => (
                                    <TableRow key={row.id || index} hover sx={{ height: 32 }}>
                                        <StyledCell>{index + 1}</StyledCell>
                                        <StyledCell>{row.Name || 'N/A'}</StyledCell>
                                        <StyledCell>
                                            <StatusBadge status={row.status} value={row.TotalCount ?? '0'} />
                                        </StyledCell>
                                        <StyledCell>{row.TotalPerc ?? '0'}</StyledCell>
                                        <StyledCell>
                                            <StatusBadge status="open" value={row.TotalRowCount ?? '0'} />
                                        </StyledCell>
                                        <StyledCell>
                                            <StatusBadge status="close" value={row.ExtraPer ?? '0'} />
                                        </StyledCell>
                                        <StyledCell>
                                            <StatusBadge status="cancel" value={row.RowNum ?? '0'} />
                                        </StyledCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default EnquiryDataTable;